import { Letter } from '@work4all/models/lib/Classes/Letter.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/letter-table-schema.json';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

export function LettersTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<Letter, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    forceRequestFields: {
      fileInfos: {
        fileServiceProviderInfos: {
          id: null,
          fspUrl: null,
        },
      },
    },
  });

  return (
    <EntityTableV8
      {...props}
      {...dataTable}
      onRowDoubleClick={() => {
        if (
          dataTable.selectedEntity?.fileInfos?.fileServiceProviderInfos?.fspUrl
        ) {
          window.open(
            dataTable.selectedEntity?.fileInfos?.fileServiceProviderInfos
              ?.fspUrl,
            '_blank'
          );
          return true;
        } else {
          return false;
        }
      }}
    />
  );
}
